import * as loadQueueHelper from '../../../../js/document/load-queue'
import { fromCamelCase } from '../../../../js/helpers/string'
import BookingCarRental from '../../booking-car-rental/main'

loadQueueHelper.add(function () {
  const testData = require('./test-data.json') || []
  renderJsViews(testData)

  const testAddExtraCarsData = require('./test-add-extra-cars-data.json') || []
  renderJsViews(testAddExtraCarsData, 'tests-booking-car-rental-add-extra-cars')
}, 2)

const renderJsViews = (testData, idElement = 'tests-booking-car-rental') => {
  // Break if we're not on the targeted tests page
  const keyIdElement = document.getElementById(idElement)
  if (!keyIdElement) return
  // Proceed assuming we're there.
  testData.forEach(testCase => {
    // Find for the fixtureContainer
    const testCaseId = fromCamelCase(testCase.id)
    const fixtureContainer = keyIdElement.querySelector(`#${testCaseId} .t-docs__test-case__content.t-docs__test-case__content--js`)
    if (!fixtureContainer) return
    // Render the JS view
    setTimeout(() => {
      const widget = new BookingCarRental(fixtureContainer.firstElementChild)
      widget.handleFetched({ response: testCase.data })
      widget.enableUI()
    }, 1500)
  })
  // ⚠️ IMPORTANT - Add a resolved attribute to keyIdElement letting the tests know when we're done
  keyIdElement.dataset.readyToTest = ''
}
